export default __webpack_public_path__ + "static/ak-cached/24h/media/steps-tip-before-pre-suspended.0fddbb17.svg";